<template>
  <router-view v-if="isUpdatePage" />
  <section v-else class="section page__content">
    <h1 class="title">
      Реестр смет
    </h1>

    <TableGroup
      :table-title="title"
      modal-title="Создать смету"
      namespaced="pto/project/estimate"
      :rights-all="$store.getters.rightsPtoAll"
      :init-filter="initFilter"
      :add-to-post-data="initFilter"
    >
      <template v-slot:modalForm="props">
        <FormPtoProjectEstimate
          :is-sending="props.isSendingRequest"
          @request="props.createSubmit"
          @cancel="props.closeModal"
        />
      </template>
    </TableGroup>
  </section>
</template>

<script>
import FormPtoProjectEstimate from '@/components/pto/form/FormPtoProjectEstimate'
import TableGroup from '@/components/page/TableGroup'

import { MIXIN_IS_UPDATE_PAGE } from '@/mixins/page/mixinIsUpdatePage'

import { mapGetters } from 'vuex'

export default {
  name: 'PtoProjectDetailedEstimated',
  components: {
    FormPtoProjectEstimate,
    TableGroup
  },
  mixins: [MIXIN_IS_UPDATE_PAGE],
  computed: {
    ...mapGetters('pto/project', {
      currentProject: 'getCurrentItem',
      initFilter: 'getChildrenFilter',
      title: 'getCurrentItemTitle'
    })
  }
}
</script>
